// extracted by mini-css-extract-plugin
export default {"tabs":"tableHeader_tabs__y2KoZ"};